import { useEffect, useState } from "react";
import { Link, Route } from "react-router-dom/cjs/react-router-dom.min";
import PromotionNews from "./PromotionNews";
import PromotionNotice from "./PromotionNotice";
import CompNotice from "./CompNotice";
import { useMediaQuery } from "react-responsive";
// import CompNotice from "./CompNotice";

function Promotion({ match }) {
  const [name, setName] = useState("보도 자료");
  const [cont1, setCont1] = useState("헬리오센의 관련 서비스 및");
  const [cont2, setCont2] = useState("새로운 소식을 전합니다.");

  const btnBox = document.getElementsByClassName("basic-item")[0];
  const [box, setBox] = useState(); // eslint-disable-line no-unused-vars
  const [link, setLink] = useState(window.location.href);

  const getData = (name, cont1, cont2) => {
    setName(name);
    setCont1(cont1);
    setCont2(cont2);
  };
  const getLink = (lin) => {
    setLink(lin);
  };

  useEffect(() => {
    getLink();
    setBox(btnBox);
  }, [btnBox]);

  //링크에 따른 클래스 부여
  if (link?.includes("news")) {
    classRemove(btnBox?.children);
    btnBox?.children[0].classList.add("on");
  } else if (link?.includes("notice")) {
    classRemove(btnBox?.children);
    btnBox?.children[1].classList.add("on");
  }

  //버튼 클릭시 이동(임시)
  const onMovePage = (e) => {
    const targetValue = e.target;

    classRemove(btnBox?.children);
    targetValue.parentNode.classList.add("on");
  };

  //on 클래스 삭제
  function classRemove(arr) {
    for (let i = 0; i < arr?.length; i++) {
      arr[i].classList.remove("on");
    }
  }

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <div>
      <div className="basic-main">
        <div className="basic-visual promotion-visual">
          <div className="inner">
            <h2 className="basic-visual-title">{name}</h2>
            <div className="basic-visual-cont">
              {pc ? (
                <>
                  <p>{cont1}</p>
                  <p>{cont2}</p>
                </>
              ) : (
                <>
                  <p>
                    {cont1}
                    {cont2}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="basic-tap">
          <ul className="basic-item" onClick={onMovePage}>
            <li className="basic-list">
              <Link to="/promotion/news" className="basic-link">
                보도 자료
              </Link>
              <span className="line"></span>
            </li>
            <li className="basic-list">
              <Link to="/promotion/notice" className="basic-link">
                공지사항
              </Link>
              <span className="line"></span>
            </li>
          </ul>
        </div>
      </div>
      <div className="inner basic-inner">
        <Route
          path={`${match.path}/news`}
          exact={true}
          render={() => <PromotionNews getData={getData} getLink={getLink} />}
        />
        <Route
          path={`${match.path}/notice`}
          exact={true}
          render={() => <PromotionNotice getData={getData} getLink={getLink} />}
        />
        <Route path={`${match.path}/notice/:id`} component={CompNotice} />
      </div>
    </div>
  );
}

export default Promotion;
